import type { DroppedFile } from 'src/types/file';

export type BulkUploadExtendedEntity<T = unknown> = T & {
  id: string;
  valid: boolean;
};

export type ConvertExcelDataWithSchemaFn<TExcelRow, TResultRow> = (
  rows: TExcelRow[],
) => TResultRow[];

export enum BulkUploadFormFields {
  items = 'items',
}

export type BulkUploadFormValues = {
  [BulkUploadFormFields.items]: DroppedFile[];
};
